module.exports = __webpack_public_path__ + "img/logo2.3228a087.png";